import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-consent-dialog',
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrls: ['./cookie-consent-dialog.component.scss']
})
export class CookieConsentDialogComponent {
  private readonly CONSENT_KEY = 'cookie_consent';

  constructor(
    private dialogRef: MatDialogRef<CookieConsentDialogComponent>,
    private router: Router
  ) {}

  acceptAll(): void {
    this.saveConsent('all');
    this.dialogRef.close('all');
  }

  acceptEssential(): void {
    this.saveConsent('essential');
    this.dialogRef.close('essential');
  }

  goToPrivacyPolicy(event: Event): void {
    event.preventDefault();
    this.router.navigate(['/privacy-policy']);
  }

  private saveConsent(choice: string): void {
    localStorage.setItem(this.CONSENT_KEY, choice);
  }

  static hasUserConsented(): boolean {
    return localStorage.getItem('cookie_consent') !== null;
  }

  static getConsentChoice(): string | null {
    return localStorage.getItem('cookie_consent');
  }
}